import Loader from "react-loader-spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCarSide } from "@fortawesome/free-solid-svg-icons";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import { getAllProvinces, getCityList, getZoneList } from '../store/api/LocationAPI';
import { getAllProductMainGroups } from "../store/api/GetAllProduct";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import BihamtaTable from "../../Components/BihamtaTable";
import { getTransportationChartList, deleteTransportChart, addOrUpdateTransportChart } from "../store/api/Services";
import NewNumberInput from "../../Components/NewNumberInput";
import { CheckLg, DashCircle, ExclamationTriangle, PlusSquareFill } from "react-bootstrap-icons";

const ManageTransportationChart = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState(null);
    const [submitData, setSubmitData] = useState({});
    const [chartList, setChartList] = useState([]);
    const { provinceList, cityList, zoneList, productMainGroupList } = useSelector(state => {
        return {
            provinceList: state.locationDataReducer.provinceList,
            cityList: state.locationDataReducer.cityList,
            zoneList: state.locationDataReducer.zoneList,
            productMainGroupList: state.ProductReducer.productMainGroupList
        }
    })
    function onSelectChanged(e) {
        const el = e.target;
        if (el.name === "Province") {
            dispatch(getCityList(el.value));
        }
        else if (el.name === "City") {
            dispatch(getZoneList(el.value));
        }
        else if (el.name === "Zone") {
            if (Number(el.value) > 0) {
                submitData.ZoneID = el.value;
                setSubmitData({ ...submitData, ZoneID: el.value });
                getTransportationChartList(el.value, setChartList);
            }
            else {
                submitData.ZoneID = null;
                setSubmitData({ ...submitData, ZoneID: null });
                setChartList({ Data: [] });
            }
        }
        else if (el.name === "MainGroup") {
            setSubmitData({ ...submitData, MainGroupID: el.value });
        }
    }
    function cancel() {
        setError(null);
        setSubmitData({ ZoneID: submitData.ZoneID });
    }
    function prepareForAdd() {
        setSubmitData({ ...submitData, ID: 0 });
    }
    function onSubmit() {
        setError(null);
        if (!submitData.MainGroupID) {
            setError("گروه اصلی کالا انتخاب نشده است");
            return;
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            if (res.Data) {
                const pg = productMainGroupList.find(p => Number(p.MainGroupID) === Number(submitData.MainGroupID));
                submitData.MainGroupName = pg.MainGroupName;
                if (Number(submitData.ID) === 0) {
                    submitData.ID = Number(res.Data);
                    chartList.Data.push(submitData);
                    setChartList({ ...chartList });
                }
                else if (Number(submitData.ID) > 0) {
                    const tc = chartList.Data.filter(c => Number(c.ID) !== Number(submitData.ID));
                    tc.push(submitData);
                    setChartList({ Data: tc });
                }
                setSubmitData({ ZoneID: submitData.ZoneID });

            }
        }
        addOrUpdateTransportChart(submitData, onSuccess);
    }
    function prepareForEdit(row)
    {
        if(row.e)
        {
            delete row.e;
        }
        setSubmitData(row);
    }

    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "گروه اصلی کالا", colName: "MainGroupName", showInMobile: true },
        { colTitle: "هزینه ایاب و ذهاب", colName: "TransportationCost", showInMobile: true, colType: "currency" },
        { colTitle: "سهم ثابت تکنسین", colName: "StaffFixAmount", colType: "currency" },
        { colTitle: "درصد سهم تکنسین", colName: "StaffPercentAmount" }
    ]
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        dispatch(getAllProvinces());
        dispatch(getAllProductMainGroups());
    }, [])

    return (
        <div className="container-fluid mt-1" style={{ minHeight: '80vh' }}>
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <span>
                        <FontAwesomeIcon icon={faCarSide} size="lg" />&nbsp;
                        مدیریت ایاب و ذهاب
                    </span>
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <Row className="rowBorder">
                        <Col md={3} className="form-group">
                            <label>استــان: </label>
                            {provinceList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری لیست
                                </div>
                            }
                            {provinceList && Array.isArray(provinceList) &&
                                <select className="form-control" name="Province" onChange={onSelectChanged}>
                                    <option value="">انتخاب کنید</option>
                                    {provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                </select>
                            }
                        </Col>
                        <Col md={3} className="form-group">
                            <label>شهــر: </label>
                            {cityList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری لیست
                                </div>
                            }
                            {cityList && Array.isArray(cityList) &&
                                <select className="form-control" name="City" onChange={onSelectChanged}>
                                    <option value="">انتخاب کنید</option>
                                    {cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                </select>
                            }
                        </Col>
                        <Col md={3} className="form-group">
                            <label>منطــقه: </label>
                            {zoneList === "PENDING" &&
                                <div className="form-control">
                                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                    در حال بارگذاری لیست
                                </div>
                            }
                            {zoneList && Array.isArray(zoneList) &&
                                <select className="form-control" name="Zone" onChange={onSelectChanged}>
                                    <option value="">انتخاب کنید</option>
                                    {zoneList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                </select>
                            }
                        </Col>
                    </Row>
                    {
                        Number(submitData.ZoneID) > 0 &&
                        <PlusSquareFill size={24} className="hoverIcon mt-2" color="purple" onClick={prepareForAdd} />
                    }
                    {
                        Number(submitData.ID) >= 0 &&
                        <Row>
                            <Col md={3} className="form-group">
                                <label>گروه محصول: </label>
                                {productMainGroupList === "PENDING" &&
                                    <div className="form-control">
                                        <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;
                                        در حال بارگذاری لیست
                                    </div>
                                }
                                {productMainGroupList && Array.isArray(productMainGroupList) &&
                                    <select className="form-control" name="MainGroup" onChange={onSelectChanged} defaultValue={submitData.MainGroupID ?? ""}>
                                        <option value="">انتخاب کنید</option>
                                        {productMainGroupList.map((item, i) => { return (<option key={i} value={item.MainGroupID}>{item.MainGroupName}</option>) })}
                                    </select>
                                }
                            </Col>
                            <Col md={3} className="form-group">
                                <label>هزینه ایاب و ذهاب: </label>
                                <NewNumberInput defaultValue={submitData.TransportationCost ?? 0} onChange={e => submitData.TransportationCost = e.target.value} />
                            </Col>
                            <Col md={3} className="form-group">
                                <label> سهم ثابت تکنسین: </label>
                                <NewNumberInput defaultValue={submitData.StaffFixAmount ?? 0} onChange={e => submitData.StaffFixAmount = e.target.value} />
                            </Col>
                            <Col md={3} className="form-group">
                                <label> درصد سهم تکنسین: </label>
                                <Form.Control type="number" defaultValue={submitData.StaffPercentAmount ?? 0} onChange={e => submitData.StaffPercentAmount = e.target.value} />
                            </Col>
                            {
                                error &&
                                <Row className="mt-2">
                                    <Alert variant="danger"><ExclamationTriangle size={18} />&nbsp;{error}
                                    </Alert>
                                </Row>
                            }
                            <Col md={3} className="form-group">
                                <Button variant="success" className="group-Btn" onClick={onSubmit}><CheckLg />&nbsp; ثبت تغییرات</Button>
                                <Button variant="danger" className="group-Btn" onClick={cancel}><DashCircle size={17} />&nbsp; انصراف</Button>
                            </Col>
                        </Row>
                    }
                    <BihamtaTable columns={tableCols} dataList={chartList} rowClick={prepareForEdit}/>
                </Card.Body>
            </Card>
        </div>
    )
}
export default ManageTransportationChart;